import evaluationApiClient from "common/Adapters/EvaluationApiClient/evaluationApiClient";

export function fetchOverheads(lang, data, onError, companyAccess = false) {
  return evaluationApiClient.getOverheads(lang, data, onError, companyAccess);
}

export function fetchCompanyDetail(onError, companyAccess) {
  return evaluationApiClient.getCompanyDetail(onError, companyAccess);
}

export function fetchAllOfficeSizes(lang, onError) {
  return evaluationApiClient.getAllOfficeSizes(lang, onError);
}

export function fetchAllNoga(lang, onError) {
  return evaluationApiClient.getAllNogas(lang, onError);
}

export function fetchNogaDetail(lang, nogaId, onError) {
  return evaluationApiClient.getNogaDetail(lang, nogaId, onError);
}
